// extracted by mini-css-extract-plugin
export default {"recipesPage":"Recipes_recipesPage__5P42z"};